<template>
  <div class="card shadow-lg rounded-3 py-3" style="border-radius:0; border:none">
    <div class="card-body p-1">
      <h1 class="card-title mb-3 text-dark text-uppercase" style="font-weight:700"><span
          style="color: #0092f7">Log</span> In</h1>

      <form @submit.prevent="login">
        <div class="row">
          <div class="col">
            <div class="form-floating mb-3">
              <input type="text" class="form-control"
                     v-model="username" id="floatingTextInput1" placeholder="Username"
                     required>
              <label for="floatingTextInput1">User</label>
            </div>
          </div>
        </div>
        <div class="form-floating mb-3">
          <input :type="passwordFieldType" class="form-control"
                 v-model="password" id="floatingPasswordInput"
                 placeholder="Password"
                 required
                 autocomplete="on">
          <label for="floatingPasswordInput">Password</label>
        </div>
        <label class="show-password-checkbox">
          <input type="checkbox" v-model="show_password">
          Show Password
        </label>
        <div class="text-center">
          <!--          <p class="text-danger">{{ warning }}</p> -->
          <button :disabled="loading" type="submit" class="btn">
            Login
            <span v-if="loading" class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import {errorHandler} from "@/services/errorHandler";

export default {
  name: "LoginForm",
  computed: {
    passwordFieldType() {
      return this.show_password ? 'text' : 'password';
    },
  },
  async beforeMount() {
    this.autoLogin();
  },
  data() {
    return {
      username: '',
      password: '',
      loading: false,
      warning: '',
      auth: this.$route.query.auth,
      show_password: false,
    };
  },
  methods: {
    login() {
      this.loading = true;
      return this.$store.dispatch('appLogin', {
        user: this.username,
        password: this.password,
      }).then(() => this.$router.push({name: 'GateWayView'}))
          .catch(err => this.warning = err)
          .finally(() => this.loading = false);
    },
    autoLogin() {
      if (this.auth){
        try {
          const decodedAuth = JSON.parse(window.atob(this.auth));

          this.username = decodedAuth.username ;
          this.password = decodedAuth.password;

          this.login();
        } catch (error) {
          errorHandler.tomcatError(error)
          console.error('Failed to decode or parse auth:', error);
        }
      }
    }
  },
};
</script>

<style scoped>
.btn, .btn:hover {
  background: linear-gradient(90deg, rgba(65, 105, 225, 1) 0%, rgba(30, 144, 255, 1) 100%);
  color: white;
  font-weight: 600;
  display: block;
  width: 100%;
  height: 45px;
}

.card {
  padding-left: 10px;
  padding-right: 10px;
  width: 400px;
  max-width: 95vw;
  margin-top: -3rem !important;
}

.show-password-checkbox {
  margin-bottom: 20px;
}
</style>
